import React from "react";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";

import { Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useKycDocument from "../../../hooks/useKycDocument";

function RejectKycDocument(props) {
  const { kycDocumentId, refreshPage } = props;

  const { rejectKycDocument, isLoading } = useKycDocument();

  const dispatch = useDispatch();
  const { unSetDialog } = useDialog();

  const methods = useForm();

  const { handleSubmit } = methods;

  const onSubmit = async (data) => {
    try {
      await rejectKycDocument(kycDocumentId);
      dispatch(showSuccessSnackbar("KYC document rejected successfully"));
      refreshPage();
      unSetDialog("reject");
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to reject KYC document"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to Reject ?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isLoading ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("reject")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default RejectKycDocument;
